module.exports = __webpack_public_path__ + "static/Sarah-Webster-702144f3752ddce691c709595c78567c.jpg";